import { useEffect, useRef, useState } from 'react'
import './Produse.css'
import MediumModal from '../components/Modal/MediumModal'
import AddFurnizor from '../components/new/addFurnizor'

const GET_PRODUCTS_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getProducts'
const NEW_PRODUCT_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/newProduct'
const UPDATE_PRODUCT_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/updateProduct'
const GET_SUPPLIERS_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getSuppliers'
const DELETE_PRODUCTS_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/deleteProducts'

function Produse() {
    const imageInputRef = useRef(null)

    const [produse, setProduse] = useState([])
    const [furnizori, setFurnizori] = useState([])
    const [search, setSearch] = useState('')
    const [loading, setLoading] = useState(true)
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')
    const [openId, setOpenId] = useState(null)
    const [isProductModalOpen, setIsProductModalOpen] = useState(false)
    const [modalMode, setModalMode] = useState('new')
    const [isAddFurnizorModalOpen, setIsAddFurnizorModalOpen] = useState(false)
    const [activeSupplierIndex, setActiveSupplierIndex] = useState(null)
    const [newSupplierInitialName, setNewSupplierInitialName] = useState('')
    const [selectedProducts, setSelectedProducts] = useState([])
    const [productsPage, setProductsPage] = useState(1)
    const [productsPerPage, setProductsPerPage] = useState(20)
    const [deletingProducts, setDeletingProducts] = useState(false)

    const [productForm, setProductForm] = useState({
        id: null,
        nume: '',
        imagine: '',
        imageUpload: null,
        cod_produs: '',
        serie_produs: '',
        ean: ''
    })

    const [productSuppliersForm, setProductSuppliersForm] = useState([
        {
            id: null,
            furnizor_id: '',
            link_produs: '',
            pret_furnizor: '',
            cantitate_disponibila: ''
        }
    ])

    useEffect(() => {
        getProduse()
        getFurnizori()
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => {
            setProductsPage(1)
            setSelectedProducts([])
            getProduse(search)
        }, 300)

        return () => clearTimeout(timer)
    }, [search])

    async function getProduse(searchValue = '') {
        try {
            setLoading(true)
            setError('')

            const url = searchValue.trim()
                ? `${GET_PRODUCTS_API_URL}?search=${encodeURIComponent(searchValue.trim())}`
                : GET_PRODUCTS_API_URL

            const response = await fetch(url, {
                method: 'GET'
            })

            const text = await response.text()

            if (!response.ok) {
                throw new Error(`Request failed: ${response.status}`)
            }

            const data = JSON.parse(text)

            setProduse(Array.isArray(data.products) ? data.products : data.produse || [])
        } catch (err) {
            console.error('GET PRODUSE ERROR:', err)
            setError('Nu am putut încărca produsele.')
        } finally {
            setLoading(false)
        }
    }

    async function getFurnizori() {
        try {
            const response = await fetch(GET_SUPPLIERS_API_URL, {
                method: 'GET'
            })

            const data = await response.json()

            if (!response.ok) {
                throw new Error('Get suppliers failed')
            }

            setFurnizori(Array.isArray(data.suppliers) ? data.suppliers : [])
        } catch (err) {
            console.error('GET FURNIZORI ERROR:', err)
        }
    }

    function toggleProduct(id) {
        setOpenId((currentId) => (currentId === id ? null : id))
    }
    function toggleSelectedProduct(productId) {
        setSelectedProducts((prev) =>
            prev.includes(productId)
                ? prev.filter((id) => id !== productId)
                : [...prev, productId]
        )
    }

    function toggleAllVisibleProducts(visibleProducts) {
        const visibleIds = visibleProducts.map((product) => product.id)
        const allVisibleSelected =
            visibleIds.length > 0 &&
            visibleIds.every((id) => selectedProducts.includes(id))

        setSelectedProducts((prev) => {
            if (allVisibleSelected) {
                return prev.filter((id) => !visibleIds.includes(id))
            }

            return [...new Set([...prev, ...visibleIds])]
        })
    }

    async function deleteSelectedProducts() {
        if (selectedProducts.length === 0) {
            return
        }

        const confirmed = window.confirm(
            selectedProducts.length === 1
                ? 'Ștergi produsul selectat?'
                : `Ștergi cele ${selectedProducts.length} produse selectate?`
        )

        if (!confirmed) {
            return
        }

        try {
            setDeletingProducts(true)

            const response = await fetch(DELETE_PRODUCTS_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    productIds: selectedProducts
                })
            })

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Delete products failed')
            }

            setSelectedProducts([])
            setOpenId(null)

            await getProduse(search)
        } catch (err) {
            console.error('DELETE PRODUCTS ERROR:', err)
            alert(err.message || 'Nu am putut șterge produsele.')
        } finally {
            setDeletingProducts(false)
        }
    }
    function resetForms() {
        setProductForm({
            id: null,
            nume: '',
            imagine: '',
            imageUpload: null,
            cod_produs: '',
            serie_produs: '',
            ean: ''
        })

        setProductSuppliersForm([
            {
                id: null,
                furnizor_id: '',
                furnizor_search: '',
                link_produs: '',
                pret_furnizor: '',
                cantitate_disponibila: ''
            }
        ])
    }
    function openNewProductModal() {
        resetForms()
        setModalMode('new')
        setIsProductModalOpen(true)
    }

    function openEditProductModal(product) {
        setProductForm({
            id: product.id,
            nume: product.nume || '',
            imagine: product.imagine || '',
            imageUpload: null,
            cod_produs: product.cod_produs || '',
            serie_produs: product.serie_produs || '',
            ean: product.ean || ''
        })

        setProductSuppliersForm(
            Array.isArray(product.furnizori) && product.furnizori.length > 0
                ? product.furnizori.map((supplier) => ({
                    id: supplier.id || null,
                    furnizor_id: supplier.furnizor_id || '',
                    furnizor_search: supplier.furnizor_nume || getSupplierName(supplier.furnizor_id) || '',
                    link_produs: supplier.link_produs || '',
                    pret_furnizor: supplier.pret_furnizor || '',
                    cantitate_disponibila: supplier.cantitate_disponibila ?? ''
                }))
                : [
                    {
                        id: null,
                        furnizor_id: '',
                        furnizor_search: '',
                        link_produs: '',
                        pret_furnizor: '',
                        cantitate_disponibila: ''
                    }
                ]
        )

        setModalMode('edit')
        setIsProductModalOpen(true)
    }

    function updateProductForm(field, value) {
        setProductForm((prev) => ({
            ...prev,
            [field]: value
        }))
    }

    function handleLocalImageChange(event) {
        const file = event.target.files?.[0]

        if (!file) {
            return
        }

        if (!file.type.startsWith('image/')) {
            alert('Te rog încarcă o imagine.')
            event.target.value = ''
            return
        }

        const reader = new FileReader()

        reader.onload = () => {
            setProductForm((prev) => ({
                ...prev,
                imagine: reader.result,
                imageUpload: {
                    fileName: file.name,
                    contentType: file.type,
                    fileContent: reader.result
                }
            }))
        }

        reader.readAsDataURL(file)
    }

    function updateSupplierForm(index, field, value) {
        setProductSuppliersForm((prev) =>
            prev.map((supplier, supplierIndex) =>
                supplierIndex === index
                    ? {
                        ...supplier,
                        [field]: value
                    }
                    : supplier
            )
        )
    }

    function addSupplierForm() {
        setProductSuppliersForm((prev) => [
            ...prev,
            {
                id: null,
                furnizor_id: '',
                furnizor_search: '',
                link_produs: '',
                pret_furnizor: '',
                cantitate_disponibila: ''
            }
        ])
    }

    function removeSupplierForm(index) {
        setProductSuppliersForm((prev) => prev.filter((_, supplierIndex) => supplierIndex !== index))
    }

    function getSupplierName(id) {
        const supplier = furnizori.find((item) => Number(item.id) === Number(id))
        return supplier?.nume || '-'
    }

    function getProductImage(product) {
        if (product.imagine) {
            return <img src={product.imagine} alt={product.nume} />
        }

        return <span>{String(product.nume || '?').charAt(0).toUpperCase()}</span>
    }

    async function saveProduct() {
        try {
            setSaving(true)

            const payload = {
                id: productForm.id,
                nume: productForm.nume,
                imagine: productForm.imagine,
                imageUpload: productForm.imageUpload,
                cod_produs: productForm.cod_produs,
                serie_produs: productForm.serie_produs,
                ean: productForm.ean,
                furnizori: productSuppliersForm
                    .filter((supplier) =>
                        supplier.furnizor_id ||
                        supplier.link_produs.trim() ||
                        String(supplier.pret_furnizor).trim() ||
                        String(supplier.cantitate_disponibila).trim()
                    )
                    .map((supplier) => ({
                        id: supplier.id || null,
                        furnizor_id: supplier.furnizor_id || null,
                        link_produs: supplier.link_produs || '',
                        pret_furnizor: supplier.pret_furnizor || null,
                        cantitate_disponibila: supplier.cantitate_disponibila || 0
                    }))
            }

            const response = await fetch(modalMode === 'new' ? NEW_PRODUCT_API_URL : UPDATE_PRODUCT_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Save product failed')
            }

            await getProduse(search)
            setIsProductModalOpen(false)
        } catch (err) {
            console.error('SAVE PRODUCT ERROR:', err)
            alert(err.message || 'Nu am putut salva produsul.')
        } finally {
            setSaving(false)
        }
    }

    function normalizeSupplierSearch(value) {
        return String(value || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^\p{L}\p{N}]+/gu, ' ')
            .replace(/\s+/g, ' ')
            .trim()
    }

    function getSupplierSearchResults(value) {
        const words = normalizeSupplierSearch(value).split(' ').filter(Boolean)

        if (words.length === 0) {
            return []
        }

        return furnizori
            .filter((supplier) => {
                const text = normalizeSupplierSearch([
                    supplier.alias,
                    supplier.nume,
                    supplier.cui,
                    supplier.website
                ].filter(Boolean).join(' '))

                return words.every((word) => text.includes(word))
            })
            .slice(0, 20)
    }

    function selectSupplier(index, supplier) {
        setProductSuppliersForm((prev) =>
            prev.map((item, itemIndex) =>
                itemIndex === index
                    ? {
                        ...item,
                        furnizor_id: supplier.id,
                        furnizor_search: supplier.alias || supplier.nume || ''
                    }
                    : item
            )
        )
    }

    function openCreateSupplierFromProduct(index) {
        const currentSearch = productSuppliersForm[index]?.furnizor_search || ''

        setActiveSupplierIndex(index)
        setNewSupplierInitialName(currentSearch)
        setIsAddFurnizorModalOpen(true)
    }
    const totalProductPages = Math.max(
        1,
        Math.ceil(produse.length / productsPerPage)
    )

    const paginatedProduse = produse.slice(
        (productsPage - 1) * productsPerPage,
        productsPage * productsPerPage
    )

    const visibleProductIds = paginatedProduse.map((product) => product.id)

    const allVisibleProductsSelected =
        visibleProductIds.length > 0 &&
        visibleProductIds.every((id) => selectedProducts.includes(id))

    async function copyProduct(product) {
        const text = `${product.nume || '-'}, Cod Produs: ${product.cod_produs || '-'}, EAN: ${product.ean || '-'}`

        await navigator.clipboard.writeText(text)

        const toast = document.createElement('div')
        toast.className = 'copyToast'
        toast.textContent = 'Produs copiat'

        document.body.appendChild(toast)

        setTimeout(() => {
            toast.classList.add('show')
        }, 10)

        setTimeout(() => {
            toast.classList.remove('show')

            setTimeout(() => {
                toast.remove()
            }, 250)
        }, 1800)
    }

    return (
        <section className="produsePage">
            <div className="produseHeader">
                <div>
                    <h1>Produse</h1>
                </div>

                <button
                    type="button"
                    className="addProductButton"
                    onClick={openNewProductModal}
                >
                    + Adaugă produs
                </button>
            </div>

            <div className="produseSearch">
                <span>⌕</span>

                <input
                    type="text"
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Escape') {
                            setSearch('')
                        }
                    }}
                    placeholder="Caută după denumire, cod produs, serie sau EAN..."
                />

                {search && (
                    <button
                        type="button"
                        className="searchClearButton"
                        onClick={() => setSearch('')}
                    >
                        ×
                    </button>
                )}

            </div>
            {!loading && !error && produse.length > 0 && (
                <div className="produseBulkBar">
                    <label className="coolCheckbox produseSelectAll">
                        <input
                            type="checkbox"
                            checked={allVisibleProductsSelected}
                            onChange={() => toggleAllVisibleProducts(paginatedProduse)}
                        />
                        <span></span>

                        <strong>
                            {selectedProducts.length > 0
                                ? `${selectedProducts.length} selectate`
                                : 'Selectează produse'}
                        </strong>
                    </label>

                    {selectedProducts.length > 0 && (
                        <button
                            type="button"
                            className="deleteSelectedProductsButton"
                            disabled={deletingProducts}
                            onClick={deleteSelectedProducts}
                        >
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M9 3h6l1 2h4v2H4V5h4l1-2Zm-2 6h10l-1 12H8L7 9Zm3 2v8h2v-8h-2Zm4 0v8h2v-8h-2Z" />
                            </svg>

                            {deletingProducts
                                ? 'Se șterg...'
                                : selectedProducts.length === 1
                                    ? 'Șterge produsul'
                                    : `Șterge ${selectedProducts.length} produse`}
                        </button>
                    )}
                </div>
            )}
            {loading && (
                <div className="produseMessage">
                    Se încarcă produsele...
                </div>
            )}

            {error && (
                <div className="produseError">
                    {error}
                </div>
            )}

            {!loading && !error && produse.length === 0 && (
                <div className="produseMessage">
                    Nu există produse pentru această căutare.
                </div>
            )}

            {!loading && !error && produse.length > 0 && (
                <div className="produseList">
                    {paginatedProduse.map((product) => {
                        const isOpen = openId === product.id
                        const suppliers = Array.isArray(product.furnizori) ? product.furnizori : []

                        return (
                            <article
                                className={`productCard ${isOpen ? 'productCardOpen' : ''}`}
                                key={product.id}
                            >
                                <div className="productMain">
                                    <div
                                        className="productSelectCell"
                                        onClick={(event) => event.stopPropagation()}
                                    >
                                        <label
                                            className="coolCheckbox"
                                            onClick={(event) => event.stopPropagation()}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedProducts.includes(product.id)}
                                                onChange={() => toggleSelectedProduct(product.id)}
                                            />
                                            <span></span>
                                        </label>
                                    </div>
                                    <button
                                        type="button"
                                        className="productToggle"
                                        onClick={() => toggleProduct(product.id)}
                                    >
                                        <div className="productImage">
                                            {getProductImage(product)}
                                        </div>

                                        <div className="productName">
                                            <h2>{product.nume}</h2>
                                            <p>{suppliers.length} furnizori</p>
                                        </div>

                                        <div className="productMeta">
                                            <span>Cod produs</span>
                                            <strong>{product.cod_produs || '-'}</strong>
                                        </div>


                                        <div className="productMeta">
                                            <span>EAN</span>
                                            <strong>{product.ean || '-'}</strong>
                                        </div>

                                        <span className="productArrow">›</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="copyProductButton"
                                        aria-label="Copiază produs"
                                        onClick={() => copyProduct(product)}
                                    >
                                        <svg viewBox="0 0 24 24">
                                            <path d="M16 1H6a2 2 0 0 0-2 2v12h2V3h10V1Zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16H10V7h9v14Z" />
                                        </svg>
                                    </button>
                                    <button
                                        type="button"
                                        className="editProductButton"
                                        onClick={() => openEditProductModal(product)}
                                        aria-label="Editează produs"
                                    >
                                        <svg viewBox="0 0 24 24">
                                            <path d="M3 17.25V21h3.75L17.8 9.95l-3.75-3.75L3 17.25Zm17.7-10.2c.4-.4.4-1 0-1.4l-2.35-2.35a1 1 0 0 0-1.4 0l-1.85 1.85 3.75 3.75 1.85-1.85Z" />
                                        </svg>
                                    </button>
                                </div>

                                {isOpen && (
                                    <div className="productDetails">
                                        <div className="productSupplierHeader">
                                            <span>Furnizor</span>
                                            <span>Link produs</span>

                                        </div>

                                        {suppliers.length === 0 && (
                                            <div className="emptySupplierRow">
                                                Nu există furnizori pentru acest produs.
                                            </div>
                                        )}

                                        {suppliers.map((supplier) => (
                                            <div className="productSupplierRow" key={supplier.id}>
                                                <div className="productSupplierIdentity">
                                                    <div className="productSupplierLogo">
                                                        {supplier.furnizor_logo ? (
                                                            <img
                                                                src={supplier.furnizor_logo}
                                                                alt={supplier.furnizor_nume || getSupplierName(supplier.furnizor_id)}
                                                            />
                                                        ) : (
                                                            <span>
                                                                {String(
                                                                    supplier.furnizor_nume ||
                                                                    getSupplierName(supplier.furnizor_id) ||
                                                                    '?'
                                                                )
                                                                    .charAt(0)
                                                                    .toUpperCase()}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="productSupplierText">
                                                        <strong>
                                                            {supplier.furnizor_nume || getSupplierName(supplier.furnizor_id)}
                                                        </strong>

                                                        <span>
                                                            {supplier.furnizor_cui || '-'}
                                                        </span>
                                                    </div>
                                                </div>

                                                <span>
                                                    {supplier.link_produs ? (
                                                        <a
                                                            href={supplier.link_produs}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="productLinkButton"
                                                        >
                                                            Vezi produs

                                                            <svg
                                                                viewBox="0 0 24 24"
                                                                width="14"
                                                                height="14"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                            >
                                                                <path d="M14 3h7v7" />
                                                                <path d="M10 14L21 3" />
                                                                <path d="M21 14v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h4" />
                                                            </svg>
                                                        </a>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </article>
                        )
                    })}
                </div>
            )}
            {!loading && !error && produse.length > 0 && (
                <div className="productsPagination">
                    <div className="productsPerPage">
                        <span>Afișează</span>

                        <select
                            value={productsPerPage}
                            onChange={(event) => {
                                setProductsPerPage(Number(event.target.value))
                                setProductsPage(1)
                                setSelectedProducts([])
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>

                        <span>produse</span>
                    </div>

                    <div className="productsPaginationControls">
                        <button
                            type="button"
                            disabled={productsPage === 1}
                            onClick={() => {
                                setProductsPage((prev) => Math.max(1, prev - 1))
                                setSelectedProducts([])
                                setOpenId(null)
                            }}
                            aria-label="Pagina anterioară"
                        >
                            <span className="paginationArrow">‹</span>
                            <span className="paginationText">Înapoi</span>
                        </button>

                        <span>
                            Pagina {productsPage} din {totalProductPages}
                        </span>

                        <button
                            type="button"
                            disabled={productsPage === totalProductPages}
                            onClick={() => {
                                setProductsPage((prev) =>
                                    Math.min(totalProductPages, prev + 1)
                                )
                                setSelectedProducts([])
                                setOpenId(null)
                            }}
                            aria-label="Pagina următoare"
                        >
                            <span className="paginationText">Înainte</span>
                            <span className="paginationArrow">›</span>
                        </button>
                    </div>
                </div>
            )}
            <MediumModal
                isOpen={isProductModalOpen}
                title={modalMode === 'new' ? 'Adaugă produs' : 'Editează produs'}
                onClose={() => setIsProductModalOpen(false)}
                footer={
                    <>
                        <button
                            type="button"
                            className="modalSecondaryButton"
                            onClick={() => setIsProductModalOpen(false)}
                        >
                            Anulează
                        </button>

                        <button
                            type="button"
                            className="modalPrimaryButton"
                            disabled={saving}
                            onClick={saveProduct}
                        >
                            {saving ? 'Se salvează...' : 'Salvează produs'}
                        </button>
                    </>
                }
            >
                <div className="productPremiumModal">
                    <div className="productPremiumCard">
                        <div className="productPremiumImagePanel">
                            <span className="productPremiumLabel">Imagine produs</span>

                            <button
                                type="button"
                                className="productPremiumImageDrop"
                                onClick={() => imageInputRef.current?.click()}
                            >
                                {productForm.imagine ? (
                                    <img src={productForm.imagine} alt="Preview produs" />
                                ) : (
                                    <svg viewBox="0 0 24 24">
                                        <path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2ZM8.5 11.5l2.5 3.01L14.5 10l4.5 6H5l3.5-4.5Z" />
                                    </svg>
                                )}
                            </button>

                            <input
                                ref={imageInputRef}
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={handleLocalImageChange}
                            />

                            <button
                                type="button"
                                className="productPremiumGhostButton"
                                onClick={() => imageInputRef.current?.click()}
                            >
                                Încarcă imagine
                            </button>

                            <div className="productPremiumIconInput">
                                <svg viewBox="0 0 24 24">
                                    <path d="M3.9 12a5 5 0 0 1 5-5h4v2h-4a3 3 0 0 0 0 6h4v2h-4a5 5 0 0 1-5-5Zm6.1 1v-2h4v2h-4Zm1-6h4a5 5 0 0 1 0 10h-4v-2h4a3 3 0 0 0 0-6h-4V7Z" />
                                </svg>

                                <input
                                    type="text"
                                    placeholder="Link imagine produs"
                                    value={productForm.imagine}
                                    onChange={(event) => updateProductForm('imagine', event.target.value)}
                                />
                            </div>
                        </div>

                        <div className="productPremiumMainPanel">
                            <div className="productPremiumSectionTitle">
                                <h3>Informații produs</h3>
                            </div>

                            <label className="productPremiumField productPremiumFull">
                                <span>Denumire produs</span>
                                <input
                                    type="text"
                                    value={productForm.nume}
                                    onChange={(event) => updateProductForm('nume', event.target.value)}
                                />
                            </label>

                            <div className="productPremiumCodeGrid">


                                <label className="productPremiumField">
                                    <span>Cod produs</span>
                                    <input
                                        type="text"
                                        value={productForm.cod_produs}
                                        onChange={(event) => updateProductForm('cod_produs', event.target.value)}
                                    />
                                </label>

                                <label className="productPremiumField">
                                    <span>EAN</span>
                                    <input
                                        type="text"
                                        value={productForm.ean}
                                        onChange={(event) => updateProductForm('ean', event.target.value)}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="productPremiumCard productPremiumSuppliersCard">
                        <div className="productPremiumStripeHeader">
                            <div className="productPremiumSectionIcon">
                                <svg viewBox="0 0 24 24">
                                    <path d="M3 7h18v10H3V7Zm2 2v6h14V9H5Zm2 10h10v2H7v-2ZM7 3h10v2H7V3Z" />
                                </svg>
                            </div>

                            <h3>Furnizori produs</h3>

                            <button
                                type="button"
                                className="productPremiumAddButton"
                                onClick={addSupplierForm}
                            >
                                + Furnizor
                            </button>
                        </div>

                        <div className="productPremiumSupplierFieldsHeader">
                            <span>Furnizor</span>
                            <span>Link produs furnizor</span>
                            <span></span>
                        </div>

                        {productSuppliersForm.map((supplier, index) => (
                            <div className="productPremiumSupplierRow" key={`supplier-${index}`}>
                                <label className="productPremiumField productPremiumSupplierLink">
                                    <span>Furnizor</span>

                                    <div className="supplierSmartSearch">
                                        <input
                                            type="text"
                                            value={supplier.furnizor_search || ''}
                                            placeholder="Caută furnizor..."
                                            autoComplete="off"
                                            onChange={(event) => {
                                                updateSupplierForm(index, 'furnizor_search', event.target.value)
                                                updateSupplierForm(index, 'furnizor_id', '')
                                            }}
                                        />

                                        {String(supplier.furnizor_search || '').trim().length >= 2 && !supplier.furnizor_id && (
                                            <div className="supplierSmartDropdown">
                                                {getSupplierSearchResults(supplier.furnizor_search).map((item) => (
                                                    <button
                                                        type="button"
                                                        key={item.id}
                                                        onClick={() => selectSupplier(index, item)}
                                                    >
                                                        <div className="supplierSmartLogo">
                                                            {item.logo ? (
                                                                <img src={item.logo} alt={item.nume} />
                                                            ) : (
                                                                <span>{String(item.alias || item.nume || '?').charAt(0).toUpperCase()}</span>
                                                            )}
                                                        </div>

                                                        <div className="supplierSmartInfo">
                                                            <strong>{item.alias || item.nume}</strong>
                                                            <small>{item.cui || '-'} | {item.website || '-'}</small>
                                                        </div>
                                                    </button>
                                                ))}

                                                {getSupplierSearchResults(supplier.furnizor_search).length === 0 && (
                                                    <button
                                                        type="button"
                                                        className="supplierCreateFromSearch"
                                                        onClick={() => openCreateSupplierFromProduct(index)}
                                                    >
                                                        <span className="supplierCreatePlus">+</span>

                                                        <span>
                                                            Furnizor nou? <strong>"{supplier.furnizor_search}"</strong>
                                                        </span>
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </label>

                                <label className="productPremiumField productPremiumSupplierLink">
                                    <span>Link produs furnizor</span>
                                    <input
                                        type="text"
                                        placeholder="https://furnizor.ro/produs"
                                        value={supplier.link_produs}
                                        onChange={(event) => updateSupplierForm(index, 'link_produs', event.target.value)}
                                    />
                                </label>

                                <button
                                    type="button"
                                    className="productPremiumRemoveButton"
                                    disabled={productSuppliersForm.length === 1}
                                    onClick={() => removeSupplierForm(index)}
                                >
                                    ×
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </MediumModal>
            <AddFurnizor
                isOpen={isAddFurnizorModalOpen}
                mode="new"
                initialSupplier={{
                    nume: newSupplierInitialName,
                    logo: '',
                    alias: '',
                    imageUpload: null,
                    cui: '',
                    website: '',
                    website_username: '',
                    website_password: '',
                    note: ''
                }}
                initialContacts={[]}
                initialAddresses={[]}
                onClose={() => setIsAddFurnizorModalOpen(false)}
                onSaved={async (createdSupplier) => {
                    await getFurnizori()

                    if (activeSupplierIndex !== null) {
                        setProductSuppliersForm((prev) =>
                            prev.map((item, index) =>
                                index === activeSupplierIndex
                                    ? {
                                        ...item,
                                        furnizor_id: createdSupplier?.id || item.furnizor_id,
                                        furnizor_search: createdSupplier?.alias || createdSupplier?.nume || newSupplierInitialName
                                    }
                                    : item
                            )
                        )
                    }

                    setIsAddFurnizorModalOpen(false)
                }}
            />
        </section>
    )
}

export default Produse